module.exports = __webpack_public_path__ + "static/media/count50Off_326.9ffb792f.png";